import React from 'react';
import { ArrowLeft, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0f172a] text-slate-300 p-6 md:p-12 font-sans selection:bg-purple-500/30">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-purple-400 hover:text-purple-300 mb-8 font-bold transition-colors"
        >
          <ArrowLeft size={18} /> Back to Home
        </button>

        <div className="bg-[#1e293b] border border-slate-700 rounded-3xl p-8 md:p-12 shadow-2xl">
          <div className="flex items-center gap-4 mb-8 border-b border-slate-700 pb-6">
            <div className="p-3 bg-purple-600/20 rounded-xl text-purple-400">
              <Lock size={32} />
            </div>
            <h1 className="text-3xl md:text-4xl font-black text-white">Privacy Policy</h1>
          </div>

          <div className="space-y-8 text-sm leading-relaxed">
            <section>
              <h3 className="text-lg font-bold text-white mb-3">1. Information Collection</h3>
              <p>
                We collect information you provide directly to us, such as when you create an account, connect an exchange API key, or communicate with us. This may include your email address, encrypted API credentials, and usage data.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">2. API Key Security</h3>
              <p>
                Your exchange API keys (API Key & Secret) are encrypted using <strong>AES-256</strong> military-grade encryption before being stored in our database. We never display your secret keys after the initial entry. We do not have withdrawal permissions on your exchange accounts.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">3. Use of Information</h3>
              <ul className="list-disc pl-5 space-y-2 text-slate-400">
                <li>To operate, maintain, and provide the features of the Service.</li>
                <li>To execute trades on your behalf based on your configured parameters.</li>
                <li>To send you technical notices, updates, and support messages.</li>
                <li>To analyze usage trends and improve our services.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">4. Data Sharing</h3>
              <p>
                We do not share your personal information with third parties except as necessary to provide the Service (e.g., cloud hosting providers, analytics services) or as required by law.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">5. Cookies and Tracking</h3>
              <p>
                We use cookies and similar tracking technologies to enhance your experience, maintain sessions, and analyze usage. You can manage or disable cookies through your browser settings.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">6. Data Retention</h3>
              <p>
                We retain your data only as long as necessary to provide the Service, comply with legal obligations, resolve disputes, and enforce our agreements.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">7. Your Rights</h3>
              <ul className="list-disc pl-5 space-y-2 text-slate-400">
                <li>You can request access to the personal data we hold about you.</li>
                <li>You may request corrections, deletions, or restrictions of your personal data.</li>
                <li>You can withdraw consent for data processing where applicable.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">8. Third-Party Services</h3>
              <p>
                The Service may include integrations with third-party providers. Your use of those third-party services is subject to their respective privacy policies.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">9. Changes to this Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. Updated versions will be posted on this page with a revised "Last updated" date. Continued use of the Service constitutes acceptance of the updated policy.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-bold text-white mb-3">10. Contact</h3>
              <p>
                If you have questions or concerns about this Privacy Policy or our data practices, please contact our support team via email.
              </p>
            </section>

            <div className="pt-8 border-t border-slate-700 text-xs text-slate-500">
              Last updated: February 8, 2026
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
